module.exports = __webpack_public_path__ + "static/img/index_loop_01.587dd1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/index_loop_01.png
// module id = GSnm
// module chunks = 1